import Papa from 'papaparse'
import * as XLSX from 'xlsx'
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import { saveAs } from 'file-saver'

/**
 * Export data to CSV
 */
export function exportToCSV(data, filename = 'export') {
  const csv = Papa.unparse(data)
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
  saveAs(blob, `${filename}_${getTimestamp()}.csv`)
}

/**
 * Export data to Excel
 */
export function exportToExcel(data, filename = 'export') {
  const worksheet = XLSX.utils.json_to_sheet(data)
  const workbook = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Data')
  
  const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })
  const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
  saveAs(blob, `${filename}_${getTimestamp()}.xlsx`)
}

/**
 * Export data to PDF
 */
export function exportToPDF(title, columns, data, filename = 'export') {
  const doc = new jsPDF()
  
  // Título
  doc.setFontSize(18)
  doc.text(title, 14, 22)
  
  // Fecha
  doc.setFontSize(10)
  doc.text(`Generado: ${new Date().toLocaleString('es-AR')}`, 14, 30)
  
  // Tabla
  doc.autoTable({
    head: [columns],
    body: data,
    startY: 35,
    styles: { fontSize: 8 },
    headStyles: { fillColor: [41, 128, 185] }
  })
  
  doc.save(`${filename}_${getTimestamp()}.pdf`)
}

/**
 * Get timestamp for filename
 */
function getTimestamp() {
  const now = new Date()
  return now.toISOString().replace(/[:.]/g, '-').slice(0, -5)
}

